// src/composables/usePocketbase.js
import PocketBase from 'pocketbase'

let pb

export default function usePocketbase() {
  if (!pb) {
    pb = new PocketBase(import.meta.env.VITE_POCKETBASE_URL)
    pb.autoCancellation(false) // ✅ Disable auto-cancellation globally
  }
  return pb
}
